import { render, staticRenderFns } from "./uploadForm.vue?vue&type=template&id=3c9a5476&scoped=true"
import script from "./uploadForm.vue?vue&type=script&lang=js"
export * from "./uploadForm.vue?vue&type=script&lang=js"
import style0 from "./uploadForm.vue?vue&type=style&index=0&id=3c9a5476&prod&lang=scss"
import style1 from "./uploadForm.vue?vue&type=style&index=1&id=3c9a5476&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9a5476",
  null
  
)

export default component.exports